@if (loading) {
<div class="doc-ui doc-loading">
    <p-progressSpinner strokeWidth="4" [style]="{ width: '48px', height: '48px' }"></p-progressSpinner>
</div>
}

@if (failed) {
<app-message severity="warn" title="Cet article n'a pas pu être affiché"
    [messages]="['Il a peut-être été renommé. Revenez à l\'accueil de la documentation pour le retrouver.']"></app-message>
}

@if (article && !loading) {
<div class="doc-ui" [class.doc-art--dense]="dense">

    <!-- Bandeau de méta : la nature de l'article, sa section, sa durée de
         lecture. En fenêtre, la durée saute — on n'y vient pas pour arbitrer
         entre lire maintenant ou plus tard, mais pour se débloquer. -->
    <div class="doc-art__meta">
        <app-documentation-type-badge [type]="article.type"></app-documentation-type-badge>
        @if (sectionTitle) {
        <span class="doc-art__meta-item"><i class="{{ sectionIcon }}"></i>{{ sectionTitle }}</span>
        }
        @if (!dense) {
        <span class="doc-art__meta-item"><i class="pi pi-clock doc-art__meta-icon"></i>{{ article.readingTime }}
            min</span>
        }
    </div>

    <h1 class="doc-art__title">{{ article.title }}</h1>
    @if (article.description) {
    <p class="doc-art__lede">{{ article.description }}</p>
    }

    @if (lockedFeature) {
    <app-message severity="warn" title="Cette fonctionnalité n'est pas comprise dans votre abonnement"
        [messages]="['Vous pouvez lire cet article pour savoir ce qu\'elle apporte, mais l\'écran décrit n\'est pas accessible depuis votre dossier.']"
        [primaryAction]="discoverFeatureAction"></app-message>
    }

    <!-- `h-auto` défait le `h-full` que `BaseComponent` pose sur tout hôte : la
         hauteur du corps de l'article est celle de son texte, jamais celle du
         conteneur — sans quoi les blocs de fin se placent après un vide de la
         hauteur de l'écran. -->
    <app-documentation-content class="h-auto doc-art__body" [articleId]="article.id" [html]="content" [dense]="dense"
        (navigate)="onNavigate($event)"></app-documentation-content>

    <!-- Blocs de fin : deux cartes en grille, l'une sous l'autre en dessous de
         1024 px. Chaque lien porte le point de couleur de sa nature. -->
    @if (next.length || related.length) {
    <div class="doc-end">
        @if (next.length) {
        <div class="doc-end__card">
            <div class="doc-end__title">À lire ensuite</div>
            @for (item of next; track item.id) {
            <a class="doc-end__link" [href]="articleHref(item)" (click)="onClickArticle($event, item)">
                <span class="doc-type-dot doc-type-dot--{{ item.type }}"></span>
                <span>{{ item.title }}</span>
            </a>
            }
        </div>
        }

        @if (related.length) {
        <div class="doc-end__card">
            <div class="doc-end__title">Articles connexes</div>
            @for (item of related; track item.id) {
            <a class="doc-end__link" [href]="articleHref(item)" (click)="onClickArticle($event, item)">
                <span class="doc-type-dot doc-type-dot--{{ item.type }}"></span>
                <span>{{ item.title }}</span>
            </a>
            }
        </div>
        }
    </div>
    }
</div>
}
